const distributorAccounting = {
  Off: 'Desactivado',
  'Accounting monitor health': 'Estado del monitor contable',
  'Global worker health across all distributors. It does not verify payment or accounting readiness.':
    'Estado global del proceso para todos los distribuidores. No verifica si los pagos o la contabilidad están listos.',
  'Global pending records: {pending} · Global reviews required: {review}':
    'Registros pendientes globales: {pending} · Revisiones globales requeridas: {review}',
  'Last successful accounting check': 'Última verificación contable correcta',
  'Accounting monitor health is unavailable. Readiness is unconfirmed.':
    'El estado del monitor contable no está disponible. No se ha confirmado si está listo.',
  'This payment request was not submitted. Purchase accounting needs review. Contact MedEffects before authorizing again.':
    'Esta solicitud de pago no se envió. La contabilidad de la compra requiere revisión. Comuníquese con MedEffects antes de volver a autorizar.',
  'This product family is unavailable. Remove its mapping before saving, or clear the draft mapping.':
    'Esta familia de productos no está disponible. Elimine su asignación antes de guardar o elimine el borrador de la asignación.',
  Queued: 'En cola',
  Updated: 'Actualizado',
  'Accounting posting status': 'Estado de registro contable',
  'Review existing accounting records. This view does not retry or create financial entries.':
    'Revise los registros contables existentes. Esta vista no reintenta ni crea asientos financieros.',
  'Refresh accounting status': 'Actualizar estado contable',
  'View accounting status': 'Ver estado contable',
  'Loading accounting status...': 'Cargando estado contable...',
  'Accounting status could not load. Please refresh.':
    'No se pudo cargar el estado contable. Actualice la vista.',
  'Pending: {pending} · Recorded: {recorded} · Needs review: {review}':
    'Pendientes: {pending} · Registrados: {recorded} · Requieren revisión: {review}',
  'No accounting records on this page.': 'No hay registros contables en esta página.',
  'Bank entry reference': 'Referencia del asiento bancario',
  'Previous accounting page': 'Página contable anterior',
  'Next accounting page': 'Página contable siguiente',
  'Accounting page {page}': 'Página contable {page}',
  'Invoice needs verification': 'La factura requiere verificación',
  'Invoice recorded': 'Factura registrada',
  'Payment needs verification': 'El pago requiere verificación',
  'Accounting mapping is not configured.': 'La asignación contable no está configurada.',
  'Accounting posting is disabled.': 'El registro contable está desactivado.',
  'Accounting mapping needs verification.': 'La asignación contable requiere verificación.',
  'Accounting is limited to sandbox testing.':
    'La contabilidad está limitada a pruebas en el entorno de prueba.',
  'Sandbox accounting checks are ready. Live activation remains off.':
    'Las verificaciones contables del entorno de prueba están listas. La activación en producción sigue desactivada.',
  'Accounting settings could not be confirmed. Your edits are still here. Discard and reload before saving again.':
    'No se pudo confirmar la configuración contable. Sus cambios se conservan. Descártelos y vuelva a cargar antes de guardar de nuevo.',
  'Accounting settings could not load. Please retry.':
    'No se pudo cargar la configuración contable. Inténtelo de nuevo.',
  'Complete the buyer, company, family, deposit, tax and clearance-date mappings before saving.':
    'Complete las asignaciones de comprador, empresa, familia, depósito, impuestos y fecha de compensación antes de guardar.',
  'Draft accounting mapping cleared.': 'Se eliminó el borrador de la asignación contable.',
  'Accounting mapping saved as a draft. Live activation remains off.':
    'La asignación contable se guardó como borrador. La activación en producción sigue desactivada.',
  'Accounting settings changed. Your edits are still here. Discard and reload before saving again.':
    'La configuración contable cambió. Sus cambios se conservan. Descártelos y vuelva a cargar antes de guardar de nuevo.',
  'Distributor accounting settings': 'Configuración contable del distribuidor',
  'Accounting settings for {name}': 'Configuración contable de {name}',
  'Map the exact distributor buyer and approved QuickBooks accounts. The pricing account does not identify the buyer.':
    'Asigne el comprador exacto del distribuidor y las cuentas aprobadas de QuickBooks. La cuenta de precios no identifica al comprador.',
  'These draft mappings do not activate payments, post accounting entries or add bank units.':
    'Estas asignaciones de borrador no activan pagos, no registran asientos contables ni agregan unidades al banco.',
  'This distributor is inactive. Accounting settings are read-only.':
    'Este distribuidor está inactivo. La configuración contable es de solo lectura.',
  'Configure accounting': 'Configurar contabilidad',
  'Checking accounting settings...': 'Consultando configuración contable...',
  'Accounting treatment': 'Tratamiento contable',
  'Sale on verified payment clearance': 'Venta al confirmar la compensación del pago',
  Currency: 'Moneda',
  'Save draft accounting mapping': 'Guardar borrador de asignación contable',
  'Discard accounting edits and reload': 'Descartar cambios contables y volver a cargar',
  'Clear draft accounting mapping': 'Eliminar borrador de asignación contable',
  'Exact legal buyer name': 'Nombre legal exacto del comprador',
  'QuickBooks company ID': 'ID de la empresa de QuickBooks',
  'QuickBooks buyer customer ID': 'ID de cliente del comprador en QuickBooks',
  'QuickBooks environment': 'Entorno de QuickBooks',
  'Choose environment': 'Elegir entorno',
  Sandbox: 'Entorno de prueba',
  Production: 'Producción',
  'Enter IDs from the approved QuickBooks company. Saving checks the linked company; it does not create customers, items or accounts.':
    'Ingrese los ID de la empresa aprobada de QuickBooks. Al guardar se verifica la empresa vinculada; no se crean clientes, artículos ni cuentas.',
  'Product-family accounting items': 'Artículos contables por familia de productos',
  'No product families are available for accounting mapping.':
    'No hay familias de productos disponibles para la asignación contable.',
  'Map accounting for {family}': 'Asignar contabilidad para {family}',
  'QuickBooks item ID for {family}': 'ID del artículo de QuickBooks para {family}',
  'Income account ID for {family}': 'ID de la cuenta de ingresos para {family}',
  'Deposit accounts by payment method': 'Cuentas de depósito por método de pago',
  'Map {method} deposit account': 'Asignar cuenta de depósito de {method}',
  'Deposit account ID for {method}': 'ID de la cuenta de depósito de {method}',
  'I confirm this USD sale is approved as non-taxable (NON).':
    'Confirmo que esta venta en USD está aprobada como no sujeta a impuestos (NON).',
  'Accounting posting date': 'Fecha de registro contable',
  'Choose posting date convention': 'Elegir criterio de fecha de registro',
  'Use the date in verified payment-clearance evidence':
    'Usar la fecha de la evidencia verificada de compensación del pago',
  'The posting date must come from actual cleared-payment evidence. It is never inferred from today or the browser time zone.':
    'La fecha de registro debe provenir de evidencia real de compensación del pago. Nunca se deduce de la fecha actual ni de la zona horaria del navegador.',
};
export default distributorAccounting;
